import classNames from 'classnames';

import type { ReactNode } from 'react';

import './secondaryKpiCard.scss';

export type SecondaryKpiCardProps = {
  iconClass: string;
  label: string;
  value: string;
  roiHeader?: boolean;
  children?: ReactNode;
};

export function SecondaryKpiCard({ iconClass, label, value, roiHeader, children }: SecondaryKpiCardProps) {
  const iconAndLabel = roiHeader ? (
    <div className="kpiOverview__labelContainer">
      <i className={classNames(iconClass, 'kpiOverview__secondaryIcon')} />
      <span className="kpiOverview__label">{label}</span>
    </div>
  ) : (
    <>
      <i className={classNames(iconClass, 'kpiOverview__secondaryIcon')} />
      <span className="kpiOverview__label">{label}</span>
    </>
  );

  return (
    <div className="kpiOverview__secondaryCard">
      <div className={classNames('kpiOverview__secondaryHeader', { 'kpiOverview__secondaryHeader--roi': roiHeader })}>
        {iconAndLabel}
        {children}
      </div>
      <span className="kpiOverview__secondaryValue">{value}</span>
    </div>
  );
}
